
import React from 'react';
import { getImageUrl, getAuthCurrentLang, isSafe2Travel } from '~/common';
import { formatMessage } from '~/locales';

class SignOut extends React.Component {

    render() {
        const isS2t = isSafe2Travel();
        return <div className="auth0-lock-container">
            <div className="auth0-lock auth0-lock-opened">
                <div className="auth0-lock-center">
                    <div className="auth0-lock-widget auth0-lock-widget-sign-out">
                        <div className="auth0-lock-widget-container">
                            <div className="auth0-lock-cred-pane auth0-lock-quiet auth0-lock-sign-out">
                                <div className="auth0-lock-cred-pane-internal-wrapper">
                                    <div className="auth0-lock-header">
                                        <div className="auth0-lock-header-bg auth0-lock-blur-support">
                                            <div className="auth0-lock-header-bg-blur"></div>
                                        </div>
                                        <div className="auth0-lock-header-welcome">
                                            <img alt="" className="auth0-lock-header-logo" src={getImageUrl(isS2t ? "safe_2_travel_logo.svg" : "ctm-logo.png")} />
                                            <div className="auth0-lock-name"><span>{isS2t ? "Safe2Travel Portal" : "CTM Portal"}</span></div>
                                        </div>
                                    </div>
                                    <div className="auth0-lock-content-wrapper">
                                        <div className="auth0-lock-body-content">
                                            <div className="auth0-lock-content">
                                                <div className="auth0-lock-form">
                                                    {formatMessage({ id: 'you_have_signed_out', lang: getAuthCurrentLang(), values: [isS2t ? 'Safe2Travel Portal' : 'CTM Portal'] })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    }
}
export default SignOut